export default __webpack_public_path__ + "static/media/S-033.2039e6f1.png";